import * as tslib_1 from "tslib";
import "../../CommonImports";
import "../../Core/core.css";
import "./ExpandableTextField.css";
import * as React from "react";
import { Expandable } from '../../Expandable';
import { TextField } from '../../TextField';
import { css } from '../../Util';
var textFieldId = 1;
var ExpandableTextField = /** @class */ (function (_super) {
    tslib_1.__extends(ExpandableTextField, _super);
    function ExpandableTextField(props) {
        var _this = _super.call(this, props) || this;
        _this.textFieldElement = React.createRef();
        _this.containerElement = React.createRef();
        _this.expandable = React.createRef();
        _this.collapse = function () {
            if (_this.expandable.current) {
                _this.expandable.current.collapse();
            }
        };
        _this.expand = function () {
            if (_this.expandable.current) {
                _this.expandable.current.expand();
            }
        };
        _this.onBlur = function () {
            if (_this.props.blurDismiss) {
                _this.collapse();
            }
            if (_this.props.onBlur) {
                _this.props.onBlur();
            }
        };
        _this.renderCallout = function () {
            return _this.props.renderCallout(_this, _this.dropdownId, _this.props.anchorElement
                ? _this.props.anchorElement
                : !_this.props.anchorPoint
                    ? _this.containerElement.current
                        ? _this.containerElement.current
                        : undefined
                    : undefined, _this.props.anchorOffset || { horizontal: 0, vertical: 0 }, _this.props.anchorOrigin || { horizontal: "end" /* end */, vertical: "end" /* end */ }, _this.props.anchorPoint, _this.props.dropdownOrigin || { horizontal: "end" /* end */, vertical: "start" /* start */ });
        };
        _this.dropdownId = props.dropdownId || "dropdown-" + textFieldId++;
        return _this;
    }
    ExpandableTextField.prototype.render = function () {
        var _this = this;
        return (React.createElement(Expandable, { disabled: this.props.disabled, expandKey: this.props.expandKey, onCollapse: this.props.onCollapse, onExpand: this.props.onExpand, renderCallout: this.renderCallout, ref: this.expandable }, function (expandableProps) {
            return (React.createElement("div", { className: "bolt-expandable-textfield", onMouseDown: expandableProps.onMouseDown, onKeyDown: expandableProps.onKeyDown, ref: _this.containerElement },
                React.createElement(TextField, tslib_1.__assign({}, _this.props, { ariaControls: expandableProps.expanded ? _this.dropdownId : undefined, ariaExpanded: expandableProps.expanded, ariaHasPopup: true, className: _this.props.className, onBlur: _this.onBlur, onClick: expandableProps.onClick, ref: _this.textFieldElement, suffixIconProps: !_this.props.hideDropdownIcon
                        ? {
                            key: "dropdown-icon",
                            className: css("bolt-expandable-textfield-icon icon-right", _this.props.disabled && "disabled"),
                            iconName: "ChevronDown",
                            onClick: expandableProps.onClick
                        }
                        : undefined }))));
        }));
    };
    ExpandableTextField.prototype.focus = function () {
        if (this.textFieldElement.current) {
            this.textFieldElement.current.focus();
        }
    };
    ExpandableTextField.defaultProps = {
        expandKey: [40 /* downArrow */, 13 /* enter */]
    };
    return ExpandableTextField;
}(React.Component));
export { ExpandableTextField };
